<template>
  <div>
    <div class="container-home">
      <div class="swiper">
        <a-carousel arrows>
          <div
            slot="prevArrow"
            slot-scope="props"
            class="custom-slick-arrow"
            style="left: 50px;z-index: 9999;"
          >
            <a-icon type="left-circle" />
          </div>
          <div
            slot="nextArrow"
            slot-scope="props"
            class="custom-slick-arrow"
            style="right: 50px;z-index: 9999;"
          >
            <a-icon type="right-circle" />
          </div>

          <div
            class="swiper_item"
            v-for="(item, index) in swiperList"
            :key="index"
          >
            <div class="go-link" @click="goLink(item, index)"></div>
            <img
              class="banner-h5"
              :src="item.mobile_cover_image"
              alt=""
              @click="goLink(item, index)"
            />
            <img
              class="banner-pc"
              :src="item.cover_image"
              alt=""
              @click="goLink(item, index)"
            />
            <div class="titleList">
              <span class="title" @click="goLink(item, index)">{{
                item.title
              }}</span>
              <!-- <div class="title">{{ item.title }}</div> -->
            </div>
          </div>
        </a-carousel>
      </div>
      <div class="container">
        <div class="top">
          <div class="size left" @click="goSugession">
            <img src="../../assets/img/形状 10 拷贝.png" alt="" />
            <div>合理化建议</div>
          </div>
          <div class="size center" @click="goComplaint">
            <img src="../../assets/img/圆角矩形 3.png" alt="" />
            <div>投诉举报</div>
          </div>
          <div class="size right" @click="goCommend">
            <img src="../../assets/img/形状 5.png" alt="" />
            <div>表彰表扬</div>
          </div>
        </div>
        <div class="bottom" @click="viewFile">
          <img src="../../assets/img/形状 14.png" alt="" />
          <span>总裁直通车管理制度</span>
          <div class="SubBtn">查看文件</div>
          <!-- <a href="" class="SubBtn">查看文件</a> -->
        </div>
      </div>
    </div>
    <Tabs v-if="windowWidth() < 767"></Tabs>
  </div>
</template>

<script>
import { $get_banner_list, $get_agreement } from "@/api/index.js";

import Tabs from "../../components/tabs.vue";
export default {
  name: "Home",
  components: { Tabs },
  data() {
    return {
      agreement: "", // 协议
      title:
        "这个是轮播图标题这个是轮播图标题这个是轮播图标题这个是轮播图标题这个是轮播图标题",
      active: 0, // Tabbar 选中 下标
      swiperList: [],
      iconHome: {
        active: "@/assets/img/形状_65_拷贝.png",
        inactive: "@/assets/img/形状_65_拷贝_2.png",
      },
      iconMy: {
        active: "@/assets/img/形状_39_拷贝.png",
        inactive: "@/assets/img/形状_39.png",
      },
    };
  },

  // 数据监听
  watch: {},
  // 组件被挂载之后
  async mounted() {
    if (this.$route.query.mid) {
      this.$store.dispatch("permissions/saveMid", this.$route.query.mid);
    }
    try {
      let res = await $get_banner_list();
      this.swiperList = res.data;
      console.log();
    } catch (error) {}
    try {
      let res = await $get_agreement({ id: 1 });
      this.agreement = res.data.content;
    } catch (error) {}
  },
  methods: {
    // 轮播图跳转
    goLink(item, index) {
      // return;
      if (item.banner_type == 2) {
        window.open(item.url, "_blank");
      }
      if (item.banner_type == 3) {
        this.$router.push({
          name: "bannerFile",
          query: { index },
        });
      }
    },

    // 合理化建议
    goSugession() {
      this.$router.push("/suggestion");
    },
    // 投诉举报
    goComplaint() {
      this.$router.push("/complaint");
    },
    // 表彰表扬
    goCommend() {
      this.$router.push("/commend");
    },
    // 问题反馈和处理机制
    viewFile() {
      this.downloadImage(this.agreement);
      const a = document.createElement("a");
      a.href = this.agreement;
      a.target = "_blank";
      document.body.appendChild(a);
      a.click();
      a.remove();
    },
    downloadImage(url, name) {
      console.log(11);
      var xhr = new XMLHttpRequest();
      xhr.open("GET", url, true);
      xhr.responseType = "blob";
      xhr.onload = function() {
        if (xhr.status === 200) {
          var urlCreator = window.URL || window.webkitURL;
          var imageUrl = urlCreator.createObjectURL(xhr.response);
          var tag = document.createElement("a");
          tag.href = imageUrl;
          tag.download = name || "问题反馈和处理机制";
          document.body.appendChild(tag);
          tag.click();
          document.body.removeChild(tag);
        }
      };
      xhr.send();
    },
  },
};
</script>

<style lang="less" scoped>
// PC样式

@media (min-width: 767px) {
  .container-home {
    box-sizing: border-box;
    background-color: #f5f5f5;

    .swiper {
      position: relative;

      .banner-pc {
        display: block;
      }

      .banner-h5 {
        display: none;
      }

      // 轮播图标题
      .titleList {
        width: 1920px;
        height: 50px;
        background-color: rgba(0, 0, 0, 0.3);
        position: absolute;
        bottom: 5px;
      }

      .title {
        display: block;
        width: 1280px;
        height: 50px;
        color: #fff;
        font-size: 20px;
        font-family: PingFang SC;
        font-weight: 500;
        text-align: left;
        margin: 0 auto;
        line-height: 50px;
        z-index: 9999;
        cursor: pointer;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      // 上/下一张按钮
      .ant-carousel .slick-slide {
        text-align: center;
        height: 160px;
        line-height: 160px;
        background: #364d79;
        overflow: hidden;
      }

      /deep/ .anticon-right-circle,
      /deep/.anticon-left-circle {
        font-size: 50px;
      }

      .ant-carousel .custom-slick-arrow {
        width: 55px;
        height: 55px;
        font-size: 25px;
        color: #fff;
        background-color: rgba(31, 45, 61, 0.11);
        opacity: 0.3;
      }

      .ant-carousel .custom-slick-arrow:before {
        display: none;
      }

      .ant-carousel .custom-slick-arrow:hover {
        opacity: 0.5;
      }

      // 上/下一张按钮

      .swiper_item {
        width: 100%;
        height: 384px;
      }

      .swiper_item img {
        width: 100%;
        height: 100%;
        cursor: pointer;
        object-fit: cover;
      }

      .ant-carousel {
        margin: 0 auto;
      }

      .ant-carousel .slick-slider {
        object-fit: cover;
        width: 100%;
        height: 412px;
        overflow: hidden;
      }

      /deep/.ant-carousel .slick-dots-bottom {
        margin-bottom: 60px;
      }

      /deep/.ant-carousel .slick-dots li button {
        width: 12px;
        height: 12px;
        background: #333333;
        border-radius: 50%;
        margin-bottom: 10px;
      }

      /deep/.slick-active button {
        width: 12px;
        height: 12px;
        background: #ffffff !important;
        border-radius: 50%;
        margin-bottom: 60px;
      }
    }

    .container {
      max-width: 1280px;
      height: auto;
      background: #ffffff;
      margin: 16px auto;
      padding: 71px 89px;

      .top {
        display: flex;
        justify-content: space-between;

        .size {
          width: 357px;
          height: 171px;
          background: #ffffff;
          border: 1px solid #cfcfcf;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          font-size: 20px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #333333;
          cursor: pointer;
        }

        .size:hover {
          transition: all 0.3s;
          background-color: #f4f4f4;
        }
      }

      .bottom {
        max-width: 1103px;
        height: 177px;
        background: #ffffff;
        border: 1px solid #cfcfcf;
        margin-top: 15px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;

        span {
          font-size: 28px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #222222;
          margin-left: 18px;
          margin-right: 32px;
        }

        div {
          width: 150px;
          height: 52px;
          background: #e60012;
          border-radius: 4px;
          font-size: 20px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #ffffff;
          text-align: center;
          line-height: 52px;
        }
      }

      .bottom:hover {
        transition: all 0.3s;
        background-color: #f4f4f4;
      }
    }
  }
}

// H5样式
@media (max-width: 767px) {
  .container-home {
    box-sizing: border-box;
    height: auto;
    background-color: #ffffff;
    padding: 0 16px;

    .swiper {
      width: 100%;
      height: 100%;
      margin: 10px auto;
      border-radius: 4px;
      overflow: hidden;

      .banner-h5 {
        display: block;
      }

      .banner-pc {
        display: none;
      }

      // 轮播图标题
      .titleList {
        width: 100%;
        height: auto;
        background-color: rgba(0, 0, 0, 0.3);
        position: absolute;
        bottom: 0px;
        padding: 10px 15px;
      }

      .title {
        display: block;
        width: 330px;
        font-size: 15px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #ffffff;
        line-height: 20px;
        cursor: pointer;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    /deep/.slick-dots {
      margin-bottom: 35px;
    }

    /deep/.ant-carousel .slick-dots-bottom {
      // margin-bottom: 60px;
      display: none;
    }

    .swiper_item {
      position: relative;
      width: 100%;
      height: 160px;

      .go-link {
        top: 0;
        left: 0;
        position: absolute;
        width: 100%;
        height: 160px;
      }
    }

    .swiper_item img {
      width: 100%;
      height: 160px;
      object-fit: cover;
    }

    .ant-carousel {
      width: 100%;

      height: 160px;
      margin: 0 auto;
      border-radius: 4px;
      overflow: hidden;
    }

    /deep/.slick-slide {
      height: 160px;
      pointer-events: auto;
    }

    .ant-carousel .slick-slider {
      object-fit: cover;
      overflow: hidden;
      width: 100%;
      height: 100%;
    }

    /deep/.ant-carousel .slick-dots li button {
      width: 6px;
      height: 6px;
      background: #333333;
      border-radius: 4px;
    }

    /deep/.slick-active button {
      width: 6px;
      height: 6px;
      background: #ffffff !important;
      border-radius: 4px;
    }

    .container {
      width: 100%;
      background: #ffffff;
      margin: 0px auto;

      .top {
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .left {
          img {
            width: 24px;
            height: 26px;
          }
        }

        .center {
          border-top: none !important;
          border-bottom: none !important;

          img {
            width: 27px;
            height: 27px;
          }
        }

        .right {
          img {
            width: 21px;
            height: 30px;
          }
        }

        .size {
          width: 100%;
          height: 101px;
          background: #ffffff;
          border: 1px solid #cfcfcf;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          font-size: 15px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #333333;

          div {
            margin-top: 10px;
          }
        }
      }

      .bottom {
        width: 100%;
        height: 153px;
        background: #f5f5f5;
        margin-top: 15px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        img {
          width: 24px;
          height: 28px;
        }

        span {
          font-size: 15px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #222222;
          margin-top: 10px;
          margin-bottom: 20px;
        }

        div {
          width: 110px;
          height: 38px;
          background: #ea4949;
          border-radius: 2px;
          text-align: center;
          font-size: 16px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #ffffff;
          line-height: 38px;
        }
      }
    }
  }
}
</style>
